{
  "alert.informative": "Informativ",
  "alert.negative": "Negativ",
  "alert.notice": "Hinweis",
  "alert.positive": "Positiv",
  "attachmentlist.nextAttachments": "Nächste Anhänge anzeigen",
  "attachmentlist.previousAttachments": "Vorherige Anhänge anzeigen",
  "chat.newMessage": "Neue Nachricht",
  "chat.scrollToBottom": "Zum Ende scrollen",
  "messagefeedback.thumbDown": "Fehlerhafte Antwort",
  "messagefeedback.thumbUp": "Gute Antwort",
  "promptfield.aiDisclaimer": "Antworten werden mit KI generiert und können ungenau sein. Überprüfen Sie sie vor der Verwendung.",
  "promptfield.aiUserGuidlines": "KI-Benutzerrichtlinien",
  "promptfield.attachments": "Anhänge",
  "promptfield.insertButton": "Hinzufügen",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Sind Sie bereit? Sie können Fragen stellen, Ideen teilen oder Aufgaben hinzufügen.",
  "promptfield.placeholder.small": "Beliebige Fragen stellen",
  "promptfield.stopButton": "Stoppen",
  "promptfield.submitButton": "Senden",
  "promptfield.uploading": "Upload läuft",
  "responsestatus.loading": "Ladevorgang läuft",
  "responsestatus.processing": "Verarbeitung läuft …",
  "voicebutton.startListening": "Aufzeichnung starten",
  "voicebutton.stopListening": "Aufzeichnung stoppen"
}
